/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPanelCollapseLeft = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M16.7 14.3 14.4 12l2.3-2.3-1.4-1.4-3.7 3.7 3.7 3.7z" />
      <path d="M2 2v20h20V2zm6 18H4V4h4zm12 0H10V4h10z" />
    </g>
  </Icon>
);
export { SvgPanelCollapseLeft as PanelCollapseLeft };
